export default __webpack_public_path__ + "static/media/Kartika.09aadea0.ttf";